import { isEmpty } from 'serenova-js-utils/strings';
import store from '../../../redux/store';

import {
    formTypeHasSubtypes
  } from '../../../redux/modules/entities/amr/selectors';

export const formValidation = values => {

    function checkinteractionIDCount(interactionIds) {
        let interactionRequestCount = interactionIds && values.get('interactionIds').split(',');
        if (interactionRequestCount.length > 200) {
            return true && `Interaction Id count should be less than equal to 200.Current Interaction Id Count:-${interactionRequestCount.length}`
        }
        else {
            return false;
        }
    }

    const getCheck = (artifactTypeId,artifactSubType) => {
        if(formTypeHasSubtypes(store.getState())){
          return isEmpty(artifactSubType) || artifactSubType == undefined || artifactSubType == '';
        }else {
          return false;
        }
      }
    let validInteractionIds = values.get('interactionIds') && values.get('interactionIds').split(',')
        .map((interactionId) => interactionId.replace(/[\r\n]/gm, ''))
        .every((interactionId) => interactionId.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"));

    var obj = {
        description: isEmpty(values.get('description')) && 'Please enter a Description',
        requestType: isEmpty(values.get('requestType')) && 'Please select Request Type',
        requestedArtifactTypeId: isEmpty(values.get('requestedArtifactTypeId')) && 'Please select Artifact Type',
        requestedArtifactSubType: getCheck(values.get('requestedArtifactTypeId'),values.get('requestedArtifactSubType')) && 'Please enter Artifact Subtype.',
        interactionIds: isEmpty(values.get('interactionIds')) && 'Please entire Interaction Id\'s' ||
                        !validInteractionIds && 'Please enter valid interaction Id\'s separated by comma' ||
                        checkinteractionIDCount( values.get('interactionIds'))
                         
    }
    if(values.get('requestType')=="add-lock"){
       obj.tncAccepted= isEmpty(values.get('tncAccepted')) && 'Please accept Terms and Conditions';
       obj.lockExpires=isEmpty(values.get('lockExpires')) && 'Please select Lock Expiry';
       obj.lockExpiryDate=isEmpty(values.get('lockExpiryDate')) && 'Please select Lock Expiry date';
    }

    if(values.get('requestType')=="remove-lock"){
        obj.tncAccepted= isEmpty(values.get('tncAccepted')) && 'Please accept Terms and Conditions';

    }

    if(values.get('requestType')=="requestType"){
        obj.tncAccepted= isEmpty(values.get('tncAccepted')) && 'Please accept Terms and Conditions';
    }

    if(values.get('requestType')=="delete"){
        obj.tncAccepted= isEmpty(values.get('tncAccepted')) && 'Please accept Terms and Conditions';
    }

    return (obj);
};